import { inject, Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { AppSettingsService } from "../app-settings.service";
import { of, take } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class SyncBalanceService {
    private appSettingsService = inject(AppSettingsService);
    private http = inject(HttpService);
    
    protected readonly baseEndpoint = this.appSettingsService.localEnv ?
        'https://localhost:44360/api/BankAccount/' :
        'BankAccount/';

    public syncBalances(): void {
        this.http.post(`${this.baseEndpoint}sync-balances`, null).pipe(take(1)).subscribe({
            next: () => console.log('Balances synchronized successfully.'),
            error: (err) => console.error('Error synchronizing balances:', err)
        });
    }

}